import React, { useState } from "react";
import PropTypes from "prop-types";

import Button from "../../Habitacional/core/Button";

import useWindowSize from "../../../hooks/useWindowSize";

import * as S from "./LinkRedirect.Style";
import { ModalResponsive } from "../Modal/Modal.Style";

const LinkRedirect = ({ as, title, description, href, children }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const { width } = useWindowSize();
  const isDesktop = width >= 768;

  const handleToggleModal = () => {
    setIsOpenModal((state) => !state);
  };

  const handleClickContinue = () => {
    if (!href) {
      return;
    }

    window.open(href);
    handleToggleModal();
  };

  return (
    <>
      <S.Button as={as || null} type="button" onClick={handleToggleModal}>
        {children}
      </S.Button>
      <ModalResponsive show={isOpenModal} onClose={handleToggleModal}>
        <header className="header">
          <h1>{title}</h1>
          <p>{description}</p>
        </header>

        <div className="divider" />

        <div className="footer">
          <Button
            variant={isDesktop ? "muted-primary" : "tertiary"}
            type="button"
            onClick={handleClickContinue}
          >
            Continuar
          </Button>
        </div>
      </ModalResponsive>
    </>
  );
};

LinkRedirect.propTypes = {
  as: PropTypes.element,
  title: PropTypes.string,
  description: PropTypes.string,
  href: PropTypes.string,
};

LinkRedirect.defaultProps = {
  as: null,
  href: null,
  title: "Você está sendo redirecionado para outro site",
  description:
    "Você será direcionado ao portal de privacidade do grupo CNP Seguros Holding, o qual a Caixa Seguradora faz parte, tudo bem?",
};

export default LinkRedirect;
